const ontarioCitiesArray = [
  {
    label: "Toronto",
    value: "Toronto"
  },
  {
    label: "Ottawa",
    value: "Ottawa"
  },
  {
    label: "Mississauga",
    value: "Mississauga"
  },
  {
    label: "Brampton",
    value: "Brampton"
  },
  {
    label: "Hamilton",
    value: "Hamilton"
  },
  {
    label: "London",
    value: "London"
  },
  {
    label: "Markham",
    value: "Markham"
  },
  {
    label: "Vaughan",
    value: "Vaughan"
  },
  {
    label: "Kitchener",
    value: "Kitchener"
  },
  {
    label: "Windsor",
    value: "Windsor"
  },
  {
    label: "Oakville",
    value: "Oakville"
  },
  {
    label: "Richmond Hill",
    value: "Richmond Hill"
  },
  {
    label: "Oshawa",
    value: "Oshawa"
  },
  {
    label: "Burlington",
    value: "Burlington"
  },
  {
    label: "St. Catharines",
    value: "St. Catharines"
  },
  {
    label: "Greater Sudbury",
    value: "Greater Sudbury"
  },
  {
    label: "Guelph",
    value: "Guelph"
  },
  {
    label: "Barrie",
    value: "Barrie"
  },
  {
    label: "Kingston",
    value: "Kingston"
  },
  {
    label: "Thunder Bay",
    value: "Thunder Bay"
  },
  {
    label: "Waterloo",
    value: "Waterloo"
  },
  {
    label: "Montreal",
    value: "Montreal"
  },
  {
    label: "Quebec City",
    value: "Quebec City"
  },
  {
    label: "Laval",
    value: "Laval"
  },
  {
    label: "Gatineau",
    value: "Gatineau"
  },
  {
    label: "Longueuil",
    value: "Longueuil"
  },
  {
    label: "Sherbrooke",
    value: "Sherbrooke"
  },
  {
    label: "Lévis",
    value: "Lévis"
  },
  {
    label: "Saguenay",
    value: "Saguenay"
  },
  {
    label: "Trois-Rivières",
    value: "Trois-Rivières"
  },
  {
    label: "Terrebonne",
    value: "Terrebonne"
  },
  {
    label: "Saint-Jean-sur-Richelieu",
    value: "Saint-Jean-sur-Richelieu"
  },
  {
    label: "Brossard",
    value: "Brossard"
  },
  {
    label: "Repentigny",
    value: "Repentigny"
  },
  {
    label: "Saint-Jérôme",
    value: "Saint-Jérôme"
  },
  {
    label: "Drummondville",
    value: "Drummondville"
  }
]

export {
  ontarioCitiesArray
};